<template>
  <footer class="vab-footer">
    <!-- Copyright -->
    <vab-icon icon="copyright-line" />
    {{ fullYear }} {{ title }} {{ version }}
  </footer>
</template>

<script>
  import { defineComponent, computed } from 'vue'
  import { useStore } from 'vuex'
  import { version } from '@/config'

  export default defineComponent({
    name: 'VabFooter',
    setup() {
      const store = useStore()

      return {
        title: computed(() => store.getters['settings/title']),
        fullYear: new Date().getFullYear(),
        version,
      }
    },
  })
</script>

<style lang="scss" scoped>
  .vab-footer {
    position: absolute;
    bottom: 9px;
    font-size: 12px;
    width: 180px;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    color: rgba(0, 0, 0, 0.15);
    text-align: center;
    // background: var(--el-color-white);
    // border-top: 1px dashed $base-border-color;

    i {
      font-size: 12px !important;
    }
  }
</style>
